import React, { useEffect } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { startExamActivity } from "../../../redux/activityAsyncAction";
import { setFullscreen } from "../../../redux/features/fullScreen/fullScreenSlice";

const StartExamModal = () => {
  const examStarted = useSelector((state) => state.timer.examStarted);
  const cam1Start = useSelector((state) => state.timer.cam1Start);
  const cam2Start = useSelector((state) => state.timer.cam2Start);
  const faceAPIloaded = useSelector((state) => state.timer.faceAPIloaded);
  const loading = useSelector((state) => state.questions.loading);
  const candidateId = useSelector((state) => state.auth.userData._id);
  const examId = useSelector((state) => state.examDetail.details._id);
  const isFullscreen = useSelector((state) => state.fullscreen.isFullscreen);
  const checkfullscreen = () =>
    window.fullScreen ||
    // eslint-disable-next-line no-restricted-globals
    (window.innerWidth == screen.width && window.innerHeight == screen.height);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFullscreen(checkfullscreen()));
    return () => {};
  }, []);

  return (
    <>
      <Modal
        show={!examStarted}
        //  show={false}
        animation={true}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="border-0">
          <Modal.Title className="text-center mx-auto">
            {isFullscreen ? "Attention" : "Enter Full-Screen"}
          </Modal.Title>
        </Modal.Header>
        {isFullscreen ? (
          <>
            <Modal.Body>
              <strong className="text-danger fw-bold">Note: </strong>We assume
              that you have read and understood the exam rules and regulations.
              Kindly ensure you adhere to the exam rules because, from hereon,
              any violation of the exam rules and regulations would attract
              either a point deduction or exam cancellation.
            </Modal.Body>
            <Modal.Footer>
              {console.log(cam1Start, cam2Start, faceAPIloaded, loading)}
              <Button
                className="mx-auto calculator-btn"
                onClick={() => {
                  dispatch(startExamActivity({ examId, candidateId }));
                }}
                disabled={
                  !(cam1Start && cam2Start && faceAPIloaded && !loading)
                }
              >
                {cam1Start && cam2Start && faceAPIloaded && !loading ? (
                  "I Understand"
                ) : (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    <span className="visually-hidden">Loading...</span>
                  </>
                )}
              </Button>
            </Modal.Footer>
          </>
        ) : (
          <>
            <Modal.Body>
              <strong className=" fw-bold"> Full-screen: </strong>We assume that
              you have read and understood the exam rules and regulations.
              Kindly ensure you adhere to the exam rules because, Full-screen
              mode is recommended during online proctoring to ensure a secure
              and fair examination process.
            </Modal.Body>
            <Modal.Footer>
              {console.log(cam1Start, cam2Start, faceAPIloaded, loading)}
              <Button
                className="mx-auto calculator-btn"
                onClick={() => {
                  dispatch(setFullscreen(true));
                }}
                disabled={
                  !(cam1Start && cam2Start && faceAPIloaded && !loading)
                }
              >
                {cam1Start && cam2Start && faceAPIloaded && !loading ? (
                  "Enter Full Screen"
                ) : (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    <span className="visually-hidden">Loading...</span>
                  </>
                )}
              </Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default StartExamModal;
